// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2dZxF","errors":"Errors_errors__RljnD"};